export { default } from "./AdvisorTeamLocked";
